var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 13.27V5h12v8.27c0 .95-.778 1.729-1.729 1.729H3.729A1.734 1.734 0 0 1 2 13.268zM14 2c.55 0 1 .45 1 1v1H1V3c0-.55.45-1 1-1h4V1h4v1h4zM6 7a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"}));
}

Trash.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Trash;

Trash.default = Trash;
